import { render, staticRenderFns } from "./recipients-overview-rate.vue?vue&type=template&id=c5417858&scoped=true&"
import script from "./recipients-overview-rate.vue?vue&type=script&lang=js&"
export * from "./recipients-overview-rate.vue?vue&type=script&lang=js&"
import style0 from "./recipients-overview-rate.vue?vue&type=style&index=0&id=c5417858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5417858",
  null
  
)

export default component.exports